import { shipping_method } from '@/utils/awards';

import Award from '@/components/award';
import Button from '@/components/button';
import Picture from '@/components/picture';

import CustomButton from '@/partials/custom_button';

import RollMp3 from '@/assets/audio/roll.mp3';
import luckyMp3 from '@/assets/audio/open.mp3';


export default {

	props: {
		/** 箱子奖品列表 */
		prizes: {
			type: Array,
			default: [],
			required: true
		},

		target_pic:{
			type: String,
			required: false
		},

		/** 按钮回调 */
		startCallBack: {
			type: Function,
			required: true
		},

		/** 结束回调 */
		endCallBack: {
			type: Function,
			required: true
		},
	},


	components: {
		'c-button': Button,
		'c-award': Award,
		'c-picture': Picture,

		'p-custom-button': CustomButton,
	},


	data() { return {
		luckygird: {
			index: -1, // 当前转动到哪个位置，起点位置
			round: 0,  // 转动次数
			prize: -1, // 中奖位置
		},
		sounds:[],
		/** ready | running */
		luck_box_status: 'ready',
	}; },

	computed: {

	},

	watch: {
	},


	async created() {

		var sounds = {
			'open': new Audio(luckyMp3),
			'roll': new Audio(RollMp3)
		};

		this.sounds = sounds;
	},

	async mounted() {
	},

	async beforeDestroy() {
	},


	methods: {
		startRoll(index){
			this.luckygird.prize = index;
			this.luckygird.index = 0;
			this.luckygird.round = 0;
			this.sounds["roll"].currentTime = 0;
			var totalMs = this.calcTotalDelay(index);
			this.sounds['roll'].playbackRate = (4500/totalMs).toFixed(2);
			this.sounds["roll"].play();

			this.Rolling();
		},
		calcTotalDelay(findex){
			var delay = 0;
			var index = 0;
			var round = 0;

			while(true){
				delay+= this.calcRoundDelay(index,round);
				index++;

				if(index>=10){
					index=0;
					round++;
				}

				if(round>6 && index == findex)
					break;
			}
			return delay;
		},
		calcRoundDelay(index,round){
			var Delay = 100- (index*5 + round*50);
			Delay = (Delay <50)?50:Delay;
			if(round > 5){
				Delay += index*2 + round*20;
			}
			return Delay;
		},
		// 开始转
		Rolling() {
			this.luck_box_status = 'running';

			var calcDelay = this.calcRoundDelay(this.luckygird.index,this.luckygird.round);
			console.log(calcDelay);

			setTimeout(() => {
				this.luckygird.index++;
				if(this.luckygird.index>=10){
					this.luckygird.index=0;
					this.luckygird.round++;
				}

				if(this.luckygird.round>6){
					if(this.luckygird.index == this.luckygird.prize)
					 return this.finishRoll();	
				}
					
				this.Rolling();
			},calcDelay);
		},
		finishRoll(){
			this.luckygird.round = 0;
			this.luck_box_status = 'ready';
			setTimeout(() => {
				this.sounds["open"].currentTime = 0;
				this.sounds["open"].play();
				this.$props.endCallBack();
			}, 500);
		},
		RollInit(){
			this.luckygird.index = -1; // 当前转到位置
			this.luckygird.round = 0; // 转动次数
			this.luckygird.prize = -1; //奖品
		},
	},

};
